<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Radio/NewDRadioEditor'
export default {
  name: 'NewDSexEditor',
  extends: compoment
}
</script>
